import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

export const SupportNote = styled(Typography.TextBody_14_20)(
    ({ theme: { palette } }) => css`
        background-color: ${palette.tertiary.background};
        padding: 12px 16px;
        width: 100%;
    `,
);

/**
 * Off-screen, unfocusable and hidden from assistive tech, so only bots that
 * fill every field ever fill it. Not named like a real field (website, url,
 * email) so browser autofill never fills it and silently drops a real message.
 */
export const HoneypotField = styled.input`
    height: 1px;
    left: -10000px;
    opacity: 0;
    position: absolute;
    width: 1px;
`;
